/** Настройки списка состава в Discord (синхронно с server/utils/staffListSettings.js) */

export const STAFF_LIST_SETTING_KEY = 'staff_list';

export const STAFF_POSITION_SLOTS = [
  'admin',
  'Chief Manager',
  'Deputy Chief Manager',
  'Chief Curator MRP',
  'Deputy Chief Curator MRP',
];

export const DEFAULT_STAFF_LIST_SETTINGS = {
  channel_id: '',
  role_sections: [
    {
      title: 'Manager',
      roles: ['Manager'],
      show_reprimands: true,
    },
    {
      title: 'Junior',
      roles: ['Junior'],
      show_reprimands: true,
    },
  ],
};

function normalizeRoleToken(value) {
  return String(value || '')
    .trim()
    .replace(/\s+/g, ' ');
}

function normalizeRoleSection(raw) {
  const source = raw && typeof raw === 'object' ? raw : {};
  const roles = Array.isArray(source.roles)
    ? source.roles.map(normalizeRoleToken).filter(Boolean)
    : String(source.roles_text || '')
        .split(/[\n,;]+/)
        .map(normalizeRoleToken)
        .filter(Boolean);

  return {
    title: normalizeRoleToken(source.title) || 'Раздел',
    roles: roles.length ? roles : [],
    show_reprimands: source.show_reprimands !== false,
  };
}

export function normalizeStaffListSettings(raw) {
  const source = raw && typeof raw === 'object' ? raw : {};
  const sections = Array.isArray(source.role_sections)
    ? source.role_sections.map(normalizeRoleSection)
    : DEFAULT_STAFF_LIST_SETTINGS.role_sections.map((s) => ({ ...s, roles: [...s.roles] }));

  return {
    channel_id: String(source.channel_id || '').trim(),
    role_sections: sections.length
      ? sections.slice(0, 8)
      : DEFAULT_STAFF_LIST_SETTINGS.role_sections.map((s) => ({ ...s, roles: [...s.roles] })),
  };
}
